import { useEffect, useRef, useState } from "react";

const whyCards = [
  {
    num: "01",
    icon: "🧠",
    title: "Curriculum Built for Industry",
    text: "Designed with input from hiring managers and engineers at top tech companies — so you learn what's actually used on the job.",
  },
  {
    num: "02",
    icon: "⚙️",
    title: "Project-First Learning",
    text: "Every module ends with a real project. You'll graduate with a deployable portfolio showcasing actual skills.",
  },
  {
    num: "03",
    icon: "👥",
    title: "Mentor-Led Small Batches",
    text: "Intentionally small groups so every student gets direct attention, code reviews, and personalized guidance.",
  },
  {
    num: "04",
    icon: "📈",
    title: "Placement Support",
    text: "Resume crafting, mock interviews, and referrals — our career team works alongside you until you land the role.",
  },
  {
    num: "05",
    icon: "🌐",
    title: "Live + Recorded Access",
    text: "Attend live sessions or catch up anytime with full recordings. Learning fits around your schedule.",
  },
  {
    num: "06",
    icon: "🚀",
    title: "Cutting-Edge Topics",
    text: "We update course content every quarter. When AI moves fast, so do we — always current, always relevant.",
  },
];

function useInView(ref) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 },
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
  return visible;
}

function AnimCard({ className, children, delay = 0 }) {
  const ref = useRef(null);
  const visible = useInView(ref);
  return (
    <div
      ref={ref}
      className={`${className} ${visible ? "visible" : ""}`}
      style={visible ? { transitionDelay: `${delay}ms` } : {}}
    >
      {children}
    </div>
  );
}
function WhyUs() {
  return (
    <section className="si-section si-why" id="why">
      <div className="si-section-label">The SwiftIntelli Advantage</div>
      <h2 className="si-h2">
        Why Choose <span style={{ color: "var(--accent2)" }}>Us</span>
      </h2>
      <p className="si-section-intro">
        We are more than just another online training platform. SwiftIntelli
        focuses on practical learning, industry focused training, and real world
        skill development to help students build strong technology careers.{" "}
      </p>
      <div className="si-why-grid">
        {whyCards.map((c, i) => (
          <AnimCard key={i} className="si-why-card" delay={i * 70}>
            <div className="si-why-num">{c.num}</div>
            <div className="si-why-icon">{c.icon}</div>
            <div className="si-why-title">{c.title}</div>
            <div className="si-why-text">{c.text}</div>
          </AnimCard>
        ))}
      </div>
    </section>
  );
}

export default WhyUs;
